import React, { useState } from "react";
import { Col, Form, Row, Radio } from "antd";
import { Helmet } from "react-helmet";

import CalculatorBanner from "../../../components/website/CalculatorBanner/CalculatorBanner";
import { CalculatorLinks } from "../../../components/website/CalculatorLinks/CalculatorLinks";
import { CalculatorResult } from "../../../components/website/CalculatorResult/CalculatorResult";
import { CalculatorContent } from "../../../components/website/CalculatorContent/CalculatorContent";

import "../../../assets/styles/calculator.css";

/* CALCULADORA SCORE CHADSVASC */
const CalculatorCHADSVA = () => {
  const [points, setPoints] = useState(0);
  const [message, setMessage] = useState("");
  const [treatment, setTreatment] = useState("");
  const [showResult, setShowResult] = useState(false);

  const [form] = Form.useForm();

  function handleSubmit(changedFields, allFields) {
    let columns = Object.keys(allFields);
    let sumPoints = 0;
    let readyToCalc = true;

    for (let i = 0; i < columns.length; i++) {
      if (allFields[columns[i]] !== null && allFields[columns[i]] !== undefined) {
        sumPoints += allFields[columns[i]];
      } else {
        readyToCalc = false;
        return;
      }
    }

    let auxTreatment = "";
    let auxMessage = "";

    if (readyToCalc) {
      if (sumPoints === 0) {
        auxTreatment = "Tratamento anti-trombótico não recomendado";
        auxMessage = "Não está recomendado o uso de anticoagulação oral para prevenção de eventos tromboembólicos na fibrilhação auricular";
      } else if (sumPoints === 1) {
        auxTreatment = "Tratamento anti-trombótico não recomendado";
        auxMessage = "Deve-se considerar o uso de anticoagulação oral para prevenção de eventos tromboembólicos na fibrilhação auricular";
      } else if (sumPoints >= 2) {
        auxTreatment = "Hipocoagulação";
        auxMessage = "Está recomendado o uso de anticoagulação oral para prevenção de eventos tromboembólicos na fibrilhação auricular";
      }

      setTreatment(auxTreatment);
      setMessage(auxMessage);
      setPoints(sumPoints);
      setShowResult(true);
    }
  }

  return (
    <>
      <Helmet>
        <title>Calculadora SCORE CHADSVA | Formação Científica em Medicina Cardiovascular</title>
        <meta
          name="description"
          content="O objetivo Cardio4all é trazer formação científica de alta qualidade, que seja eminentemente prática clínica e interativa, para ajudar os clínicos a melhorarem o diagnóstico e tratamento das doenças cardiovasculares."
        />
        <meta
          name="keywords"
          content="calculadoras área cardiovascular, Cardio4all, Medicina Cardiovascular, formação científica médica, prática clínica cardiologia, doenças cardiovasculares, formação médica em Medicina Geral e Familiar e de Medicina Interna, diagnóstico e tratamento da doença cardiovascular"
        />
        <meta property="og:title" content="Calculadora SCORE CHADSVAS | Formação Científica em Medicina Cardiovascular" />
        <meta
          property="og:description"
          content="O objetivo Cardio4all é trazer formação científica de alta qualidade, que seja eminentemente prática clínica e interativa, para ajudar os clínicos a melhorarem o diagnóstico e tratamento das doenças cardiovasculares."
        />
      </Helmet>
      <CalculatorBanner
        title={
          <span>
            SCORE CHA<sub>2</sub>DS<sub>2</sub>-VA (Fibrilhação Auricular)
          </span>
        }
      />

      <CalculatorContent>
        <Form form={form} onValuesChange={handleSubmit} className="form_calculator">
          {/* Row #1 */}
          <Row
            gutter={[
              { xs: 20, sm: 8, md: 16, lg: 60 },
              { xs: 40, sm: 8, md: 16, lg: 60 },
            ]}
          >
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Insuficiência cardíaca</p>
              <Form.Item name="cardiac" className="mt-10 w-100 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-50 mr-5">
                    Não
                  </Radio.Button>
                  <Radio.Button value={1} className="w-50 ml-5">
                    Sim
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">Não = 0 | Sim = 1 ponto</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Hipertensão arterial</p>
              <Form.Item name="hypertension" className="mt-10 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-50 mr-5">
                    Não
                  </Radio.Button>
                  <Radio.Button value={1} className="w-50 ml-5">
                    Sim
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">Não = 0 | Sim = 1 ponto</p>
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Idade</p>
              <Form.Item name="age" className="mt-10 w-100 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-33 mr-5">
                    {"< 65"}
                  </Radio.Button>
                  <Radio.Button value={1} className="w-33 mr-5 ml-5">
                    65 - 74
                  </Radio.Button>
                  <Radio.Button value={2} className="w-33 ml-5">
                    {"> 75"}
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">{"< 65 (0 pontos) | 65 - 74 (1 ponto) | > 75 (2 pontos)"}</p>
            </Col>

            {/* Row #2 */}
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold mt-10">Diabetes mellitus</p>
              <Form.Item name="diabetes" className="mt-24 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-50 mr-10">
                    Não
                  </Radio.Button>
                  <Radio.Button value={1} className="w-50 ml-10">
                    Sim
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">Não = 0 | Sim = 1 ponto</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold mt-10">AVC/AIT/tromboembolismo arterial</p>
              <Form.Item name="avc" className="mt-24 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-50 mr-10">
                    Não
                  </Radio.Button>
                  <Radio.Button value={2} className="w-50 ml-10">
                    Sim
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">Não = 0 | Sim = 2 pontos</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8}>
              <p className="blue bold">Doença vascular (doença coronária e/ou arterial periférica)</p>
              <Form.Item name="vascular" className="mt-10 mb-0">
                <Radio.Group className="w-100 d-flex flex-nowrap">
                  <Radio.Button value={0} className="w-50 mr-10">
                    Não
                  </Radio.Button>
                  <Radio.Button value={1} className="w-50 ml-10">
                    Sim
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <p className="f-14 mt-10 text-center">Não = 0 | Sim = 1 ponto</p>
            </Col>
          </Row>
        </Form>
      </CalculatorContent>

      {/* TODO: colocarmos condicao para aparecer o bloco com resultado*/}
      {showResult && (
        <CalculatorResult className={`CHADSVAS ${points === 0 ? "green" : points === 1 ? "orange" : "red"}`}>
          <Row gutter={[20, 20]} className="d-flex jc-center ai-center ml-0 mr-0">
            <Col xs={24} sm={12} md={12} lg={12} xl={12} className="d-flex flex-column jc-center">
              <p className={`bold ${points === 0 ? "green" : points === 1 ? "orange" : "red"}`}>Resultado:</p>
              <p className={`f-50 bold ${points === 0 ? "green" : points === 1 ? "orange" : "red"}`}>{points}</p>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12} className="d-flex flex-column jc-center ai-start">
              <p className={`f-18 bold ${points === 0 ? "green" : points === 1 ? "orange" : "red"}`}>{message}</p>
            </Col>
          </Row>
        </CalculatorResult>
      )}

      <CalculatorLinks />
    </>
  );
};
export default CalculatorCHADSVA;
